import { Attachment, CompanyService } from '@conveyr/shared-types';
import { AxiosInstance } from 'axios';
import baseAxios from '@/helpers/forms/axios';
import { orderInterface } from '../orders';
import { packageItemInterface } from '../packageItems';

export interface boxInterface {
    id: number
    createdAt: string
    updatedAt: string
    weightGm: number
    lengthMm: number
    widthMm: number
    heightMm: number
    boxableId: number
    boxableType: string
    boxable: object
}

export interface boxInterfaceWithLocale extends boxInterface {
    weight: number
    length: number
    width: number
    height: number
}

export interface packageInterface {
    id: number
    hash: string
    createdAt: string
    updatedAt: string
    orderId: number
    order?: orderInterface
    shippedAt: string
    arrivedAt: string
    lpn: string
    packageItems: packageItemInterface[]
    serviceLines: Array<PackageServiceLine<CompanyService>>
    attachments: Attachment[]
    box: boxInterfaceWithLocale | null
}

export interface PackageServiceLine<
    S extends CompanyService | undefined = any, // eslint-disable-line @typescript-eslint/no-explicit-any -- required for legacy compatibility; fixing would require broader type refactoring
> {
    id: number
    packageId: number
    serviceId: number
    quantity: number
    service: S
}

export default (axios: AxiosInstance = baseAxios): { updatePackage: (orderPackage: packageInterface) => Promise<packageInterface>; deletePackage: (packageId: number) => Promise<void>; } => ({
    updatePackage: async (orderPackage: packageInterface): Promise<packageInterface> => {
        const response = await axios.patch<{ package: packageInterface }>(`/api/packages/${orderPackage.id}`, orderPackage);

        return response.data.package;
    },

    deletePackage: async (packageId: number): Promise<void> => {
        return await axios.delete(`/api/packages/${packageId}`);
    },
});
